export default __webpack_public_path__ + "static/media/instagram.a31b2bcd.svg";